import { render, staticRenderFns } from "./id-or-passport.vue?vue&type=template&id=273047da&"
import script from "./id-or-passport.vue?vue&type=script&lang=js&"
export * from "./id-or-passport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports